import { observable } from "mobx";
import Model from "~/models/Model";

class CreditCard extends Model {
  /**
   * @property {number|null}
   */
  @observable creditCardId = null;

  /**
   * @property {number|null}
   */
  @observable providerId = null;

  /**
   * @property {string|null}
   */
  @observable cardName = null;

  /**
   * @property {string|null}
   */
  @observable currency = null;

  /**
   * @property {string|null}
   */
  @observable maskedCardNumber = null;

  /**
   * @property {string|null}
   */
  @observable creationDts = null;
}

export default CreditCard;
